module.exports = __webpack_public_path__ + "img/CW11WJW.a1870990.png";